export const SDK_DATA = [
    {
        name: 'Node.js',
        logo: 'https://static-00.iconduck.com/assets.00/node-js-icon-454x512-nztofx17.png',
        code: `
    const { Datura } = require('@datura/node')

    const datura = new Datura({
      apiKey: '<insert-api-key-here>',
      appId: '<insert-application-id-here>',
      consumerId: '<insert-consumer-id-here>'
    })
    
    // Declare the Unified API you want to use
    const { crm } = datura
    
    // Override consumerId serviceId as declared in initial configuration for this operation.
    const response = await crm.contactsAll({
      // serviceId: 'salesforce', // optional
      limit: 10
    })
    
    `,
    },
    {
        name: 'PHP',
        logo: 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
        code: `
    <?php
    require('vendor/autoload.php');
    
    use Datura\\Client\\Datura;
    use Datura\\Client\\DaturaConfiguration;
    
    $config = new Datura('<insert-api-key-here>', '<insert-application-id-here>', '<insert-consumer-id-here>');
    $datura = new Datura($config);
    
    $response = $datura->getCrmApi()->contactsAll(false, null, null, null, null, 1);
    
    ?>
    
    `,
    },
    {
        name: '.NET',
        logo: 'https://cdn.icon-icons.com/icons2/2415/PNG/512/dot_net_original_logo_icon_146546.png',
        code: `
    using Datura.Api;
    using Datura.Client;
    using Datura.Model;
    
    namespace Example
    {
        public class CompaniesAllExample
        {
            public static void Main()
            {
                Configuration config = new Configuration();
                // Configure API key authorization: apiKey
                config.AddApiKey("Authorization", "API_KEY");
                config.AddApiKeyPrefix("Authorization", "Bearer");
    
                var apiInstance = new CrmApi(config);
                var raw = false;  // bool? | Include raw response. Mostly used for debugging purposes (optional)  (default to false)
                var consumerId = "CONSUMER_ID";  // string | ID of the consumer which you want to get or push data from (optional)
                var appId = "APP_ID";  // string | The ID of your Unify application (optional)
                var serviceId = "salesforce";  // string | Provide the service id you want to call (e.g., pipedrive). [See the full list in the connector section.](#section/Connectors) Only needed when a consumer has activated multiple integrations for a Unified API. (optional)
    
                try
                {
                    Console.WriteLine("Calling Datura");
                    // List companies
                    GetCompaniesResponse result = apiInstance.CompaniesAll(raw, consumerId, appId, serviceId);
                    Console.WriteLine("Success", result);
                }
                catch (ApiException e)
                {
                    Console.WriteLine("Exception when calling CrmApi.CompaniesAll: " + e.Message);
                    Console.WriteLine("Status Code: " + e.ErrorCode);
                    Console.WriteLine("Detail: " + e.ErrorContent);
                }
            }
        }
    }
    
    `,
    },
    {
        name: 'Python',
        logo: 'https://cdn.icon-icons.com/icons2/112/PNG/512/python_18894.png',
        code: `
    import datura
    from datura.api import crm_api
    from datura.model.contacts_sort import ContactsSort
    from datura.model.sort_direction import SortDirection
    from pprint import pprint
    
    configuration = datura.Configuration()
    
    configuration.api_key['apiKey'] = '<insert-api-key-here>'
    configuration.api_key_prefix['apiKey'] = 'Bearer'
    
    with datura.ApiClient(configuration) as api_client:
        # Create an instance of the API class
        api_instance = crm_api.CrmApi(api_client)
        raw = False
        consumer_id = '<insert-consumer-id-here>'
        app_id = '<insert-application-id-here>'
        service_id = '<insert-service-id-here>'
        limit = 20
    
        sort = ContactsSort(
            by="name",
            direction=SortDirection("asc"),
        ) 
        
    
        try:
            # List contacts
            api_response = api_instance.contacts_all(raw=raw, consumer_id=consumer_id, app_id=app_id, service_id=service_id, limit=limit, sort=sort)
            pprint(api_response)
        except datura.ApiException as e:
            print("Exception when calling CrmApi->contacts_all: %s
    " % e)
    `,
    },
]
